import { EventEmitterClass } from './eventemitter';

export declare var EventEmitter:EventEmitterClass; 

EventEmitter = EventEmitterClass.getInstance();